export default __webpack_public_path__ + "static/media/Pessoa_juridica_on_light_blue_plus.c6a00824.svg";